import { fetch } from './api'

export async function getConversations(status = 'active') {
  const data = await fetch(`/parse/classes/ChatConversation?${new URLSearchParams({ status, limit: '50' })}`)
  return { results: data.results || [], count: data.count || 0 }
}

export async function getMessages(conversationId, { skip = 0, limit = 50 } = {}) {
  return await fetch(`/parse/classes/ChatConversation/${conversationId}/messages?${new URLSearchParams({ skip: String(skip), limit: String(limit) })}`)
}

export async function closeConversation(conversationId) {
  return await fetch(`/parse/classes/ChatConversation/${conversationId}/close`, {
    method: 'POST',
  })
}

export async function deleteConversation(conversationId) {
  return await fetch(`/parse/classes/ChatConversation/${conversationId}`, {
    method: 'DELETE',
  })
}

export async function checkAdminOnline() {
  return await fetch('/parse/classes/ChatConversation/online')
}

export async function fetchChatConfig() {
  return await fetch('/parse/chat-config')
}

export async function updateChatConfig(data) {
  return await fetch('/parse/chat-config', {
    method: 'PUT',
    body: JSON.stringify(data),
  })
}
